import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import Link from "@/components/UI/Link/Link";
import { track } from "@/track";
import Image from "next/image";

export const toExternalUrl = (url: string = "") => {
  try {
    return new URL(url);
  } catch (error) {
    try {
      return new URL(`${window.location.protocol}//${url}`);
    } catch (error) {
      return undefined;
    }
  }
};

interface ScreenshotErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  section?: any;
  screenshotUrl?: string;
}

const ScreenshotErrorState = ({ className, section, screenshotUrl, ...props }: ScreenshotErrorStateProps) => {
  return (
    <div className={classNames("flex flex-1 flex-col items-center justify-center p-5", className)} {...props}>
      <Image
        alt="Screenshot error"
        height="176"
        className="w-44"
        src="/_public-pages-service/dizzy-illustration.svg"
        width="176"
      />
      <div className="flex flex-col items-center justify-center gap-4">
        {section?.OpenInBrowserLink && (
          <Link
            endNode={<FontAwesomeIcon className="text-sm" icon={faArrowUpRightFromSquare} />}
            href={toExternalUrl(screenshotUrl) ?? ""}
            onClick={() => {
              track.signUp.jobSearchOpenPageInBrowser({
                url: screenshotUrl,
              });
            }}
            target="_blank"
            variant="external"
          >
            {section?.OpenInBrowserLink.Value}
          </Link>
        )}
        {section?.ReportProblemLink && (
          <Link
            endNode={<FontAwesomeIcon className="text-sm" icon={faArrowUpRightFromSquare} />}
            href={section?.ReportProblemLink?.Url ?? ""}
            onClick={() => {
              track.signUp.reportAProblem({
                url: screenshotUrl,
              });
            }}
            target="_blank"
            variant="external"
          >
            {section?.ReportProblemLink?.Value}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ScreenshotErrorState;
